import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import checkNormal from 'src/examples/Form/checkNormal';
import checkDisabled from 'src/examples/Form/checkDisabled';
import checkSelected from 'src/examples/Form/checkSelected';
import checkSelectedDisabled from 'src/examples/Form/checkSelectedDisabled';
import checkFeedback from 'src/examples/Form/checkFeedback';
import checkCustomLabel from 'src/examples/Form/checkCustomLabel';
import checkButtonLabel from 'src/examples/Form/checkButtonLabel';
import multipleRadioButtons from 'src/examples/Form/multipleRadioButtons';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  checkNormal,
  checkDisabled,
  checkSelected,
  checkSelectedDisabled,
  checkFeedback,
  checkCustomLabel,
  checkButtonLabel,
  multipleRadioButtons,
  React
};